<div class="section-header">
    <h2>{{ 'modules.items.title' | translate }}</h2>
    <p-button
        [label]="'modules.items.add' | translate"
        icon="pi pi-plus"
        [outlined]="true"
        size="small"
        [attr.data-test]="testId() + '-add'"
        (onClick)="add.emit()"
    />
</div>

@if (items().length > 0) {
    <div cdkDropList class="item-list" (cdkDropListDropped)="onDrop($event)">
        @for (item of items(); track item.id + item.type) {
            <div cdkDrag class="item-row">
                <div class="arrows">
                    <button type="button" class="arrow" [disabled]="$first" [attr.data-test]="testId() + '-move-up-' + item.id" (click)="moveItem($index, -1)">
                        <i class="pi pi-chevron-up"></i>
                    </button>
                    <button type="button" class="arrow" [disabled]="$last" [attr.data-test]="testId() + '-move-down-' + item.id" (click)="moveItem($index, 1)">
                        <i class="pi pi-chevron-down"></i>
                    </button>
                </div>
                <span class="name" app-value-name [id]="item.id" [type]="item.type"></span>
                <p-tag [value]="item.type | titlecase" [severity]="item.type === 'lesson' ? 'info' : 'warn'" />
                <button type="button" class="remove" [attr.data-test]="testId() + '-remove-' + item.id" (click)="remove.emit(item)">
                    <i class="pi pi-trash"></i>
                </button>
            </div>
        }
    </div>
} @else {
    <p class="empty">{{ 'modules.items.empty' | translate }}</p>
}
